import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon, PauseIcon, PlayIcon, RotateCcwIcon } from 'lucide-react';
interface PlayerControlsProps {
  playing: boolean;
  onTogglePlay: () => void;
  onBack: () => void;
  onNext: () => void;
  onRestart: () => void;
  canGoBack: boolean;
  canGoNext: boolean;
  /** 0–1 across the whole story, used for the scrub bar. */
  progress: number;
  /** Chapter boundaries as 0–1 positions, drawn as ticks on the bar. */
  markers: number[];
}
const TEXT_BUTTON = 'inline-flex items-center gap-1 rounded-full border border-white/20 px-2.5 py-1 font-body text-[11px] tracking-wide text-white/75 transition-[color,border-color,transform] duration-150 ease-out hover:border-solventum-primary hover:text-solventum-primary active:scale-[0.97] disabled:pointer-events-none disabled:border-white/10 disabled:text-white/20 md:px-3 md:text-xs';

/** The player bar: play, chapter navigation and replay over a segmented track. */
export function PlayerControls({
  playing,
  onTogglePlay,
  onBack,
  onNext,
  onRestart,
  canGoBack,
  canGoNext,
  progress,
  markers
}: PlayerControlsProps) {
  return <div className="absolute inset-x-0 bottom-0 z-10 bg-black/40 backdrop-blur-sm" data-id="element-142" data-mp="353grunh3j1rj">
      <div className="relative h-[3px] w-full bg-white/15" data-id="element-143" data-mp="310aq9t4xhyre">
        <div className="h-full bg-solventum-primary transition-[width] duration-200 ease-out" style={{
        width: `${Math.min(100, Math.max(0, progress * 100))}%`
      }} data-id="element-144" data-mp="2w293ax4dtfan" />
        {markers.map(marker => <span key={marker} aria-hidden="true" className="absolute top-0 h-full w-px bg-solventum-bg/70" style={{
        left: `${marker * 100}%`
      }} data-id="element-145" data-mp="2mc7jwimz4l22" />)}
      </div>

      <div className="flex items-center justify-between gap-2 px-2 py-2 md:px-4" data-id="element-146" data-mp="2ddccx4c3v6xp">
        <div className="flex items-center gap-1.5 md:gap-2" data-id="element-147" data-mp="28bn0bk98il7i">
          <button onClick={onTogglePlay} aria-label={playing ? 'Pause' : 'Play'} className="flex h-7 w-7 items-center justify-center rounded-full border border-white/20 text-white/80 transition-[color,border-color,transform] duration-150 ease-out hover:border-solventum-primary hover:text-solventum-primary active:scale-[0.94]" data-id="element-148" data-mp="23dv7mo0rmv29">
            {playing ? <PauseIcon className="h-3.5 w-3.5" data-id="element-149" data-mp="1oqmo8zxazjf7" /> : <PlayIcon className="h-3.5 w-3.5" data-id="element-150" data-mp="1osz7dgesrztu" />}
          </button>

          <button onClick={onBack} disabled={!canGoBack} className={TEXT_BUTTON} data-id="element-151" data-mp="2ch8ymxus5fsd">
            <ChevronLeftIcon className="h-3 w-3" data-id="element-152" data-mp="22qnr2kx4p0xb" />
            Back
          </button>

          <button onClick={onNext} disabled={!canGoNext} className={TEXT_BUTTON} data-id="element-153" data-mp="22ol09yo5j3rj">
            Next
            <ChevronRightIcon className="h-3 w-3" data-id="element-154" data-mp="2vf310t1ekt1s" />
          </button>
        </div>

        <div className="flex items-center gap-3 md:gap-4" data-id="element-155" data-mp="306l5vs6jrds1">
          <button onClick={onRestart} className={TEXT_BUTTON} data-id="element-156" data-mp="3084kzfggvis8">
            <RotateCcwIcon className="h-3 w-3" data-id="element-157" data-mp="oq16igl84nsb" />
            Replay
          </button>
          <p className="hidden pr-1 font-body text-[10px] tracking-[0.2em] text-white/30 sm:block" data-id="element-158" data-mp="jsrfwxm3m62w">
            PRECISION GRIP
          </p>
        </div>
      </div>
    </div>;
}